import { render } from "./TagPage.vue?vue&type=template&id=3985adc8&scoped=true"
import script from "./TagPage.vue?vue&type=script&lang=js"
export * from "./TagPage.vue?vue&type=script&lang=js"

import "./TagPage.vue?vue&type=style&index=0&id=3985adc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.44_typescript@6.0.3__webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3985adc8"]])

export default __exports__